import { useEffect, useRef } from 'react';

const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
export const TURNSTILE_ENABLED = !!siteKey;

// Cloudflare Turnstile "verify you are human" widget (Managed mode).
// Renders explicitly and reports its token up via onToken.
export default function TurnstileWidget({ onToken }) {
  const containerRef = useRef(null);
  const widgetIdRef = useRef(null);

  useEffect(() => {
    if (!siteKey) return undefined;
    let cancelled = false;

    const render = () => {
      if (cancelled || !window.turnstile || !containerRef.current) return;
      if (widgetIdRef.current !== null) return;
      widgetIdRef.current = window.turnstile.render(containerRef.current, {
        sitekey: siteKey,
        callback: (token) => onToken(token),
        'expired-callback': () => onToken(''),
        'timeout-callback': () => onToken(''),
        'error-callback': () => onToken(''),
      });
    };

    const timer = setInterval(() => {
      if (window.turnstile) {
        clearInterval(timer);
        render();
      }
    }, 50);

    return () => {
      cancelled = true;
      clearInterval(timer);
      if (widgetIdRef.current !== null && window.turnstile) {
        try { window.turnstile.remove(widgetIdRef.current); } catch (e) { /* noop */ }
        widgetIdRef.current = null;
      }
    };
  }, [onToken]);

  if (!siteKey) return null;
  return <div ref={containerRef} className="turnstile-widget" data-testid="turnstile-widget" style={{ margin: '4px 0 8px' }} />;
}
